// Persistente Liste der zuletzt vom User besuchten Praxen (nur IDs).
// Wohnt im localStorage, damit sie pro Browser/Gerät erhalten bleibt und
// keinen Round-Trip zum Backend braucht. Maximal MAX_RECENT Einträge,
// neueste vorn.

const STORAGE_KEY = 'medifin.recentPraxen';
const MAX_RECENT = 20;

export function getRecentPraxisIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id) => typeof id === 'string' && id.length > 0);
  } catch {
    return [];
  }
}

export function markPraxisVisited(id) {
  if (!id || typeof id !== 'string') return;
  try {
    const current = getRecentPraxisIds();
    const next = [id, ...current.filter((x) => x !== id)].slice(0, MAX_RECENT);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage voll / deaktiviert: keine UI-Konsequenz.
  }
}
